import {useState} from 'react';

export default class LoginFilter {
  public usuario: string;

  public setUsuario: any;

  public senha: string;

  public setSenha: any;

  constructor() {
    [this.usuario, this.setUsuario] = useState('');
    [this.senha, this.setSenha] = useState('');
  }
}
